<template>
  <div class="all-wrap">
    <div class="tabs">
      <div v-for="item in tabList"
           :key="item.key"
           :class="'s2b-tab-item '+(item.key===activited?'tab-item-active':'')"
           @click="changeStatusHandle(item.key)">
        {{item.lable}}
      </div>
    </div>
    <!-- 邀请购买列表 -->
    <div class="buy-list" v-show="activited === 'getWordSub'">
        <ul v-if="dataList&&dataList.length">
            <li class="buy-item" v-for="data in dataList" :key="data.productId">
                <!-- 头像 -->
                <div class="buy-img">
                    <img :src="data.avatarURL?data.avatarURL:imgUrl" />
                </div>
                <!-- 信息 -->
                <div class="buy-info">
                    <p><span>购买课程：</span>{{data.productName}}</p>
                    <p><span>返利金额：</span>{{data.rebate}}</p>
                </div>
                <!-- 注册时间 -->
                <div class="buy-time">
                    <p>购买时间：{{data.paidTime}}</p>
                </div>
            </li>
        </ul>
        <div v-else>
          <div style="text-align:center">
            <img src="@/assets/img/good/noGood.png" alt="暂无数据">
          </div>
        </div>
    </div>
    <!-- 邀请注册 -->
    <div class="buy-list" v-show="activited === 'getRegister'">
        <ul v-if="dataList&&dataList.length">
            <li class="buy-item" v-for="data in dataList" :key="data.id">
                <!-- 头像 -->
                <div class="buy-img">
                    <img :src="data.userAvatarUrl ? data.userAvatarUrl:imgUrl" />
                </div>
                <!-- 信息 -->
                <div class="buy-info">
                    <p><span>手机号：</span>{{data.mobile}}</p>
                    <p><span>邮箱：</span>{{data.email}}</p>
                </div>
                <!-- 注册时间 -->
                <div class="buy-time">
                    <p>注册时间：{{data.createTime}}</p>
                </div>
            </li>
        </ul>
        <div v-else>
          <div style="text-align:center">
            <img src="@/assets/img/good/noGood.png" alt="暂无数据">
          </div>
        </div>
    </div>
    <!-- <div class="page">
       <el-pagination
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
      :current-page="pageIndex"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper"
      style="margin:0 69px;"
    ></el-pagination>
        </div> -->
        <!-- 分页 -->
    <el-pagination background
    style="margin-top:10px;text-align: center;"
      layout="prev, pager, next, total, jumper, slot"
      prev-text="上一页"
      next-text="下一页"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage" :page-size="10" :pager-count="5"
       :total="total">
    </el-pagination>
  </div>
</template>
<script>
export default {
  data () {
    return {
      imgUrl: '../../../../../static/img/avatar-boy.gif',
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      dataList: [],
      currentPage: 1,
      lastOmit: '',
      nextOmit: '...',
      pageList: [1, 2, 3, 4, 5],
      jumpTargetPage: 1,
      activited: 'getRegister',
      tabList: [
        {
          key: 'getRegister',
          lable: '邀请注册'
        }, {
          key: 'getWordSub',
          lable: '邀请购买'
        }
      ]
    }
  },
  mounted () {
    this.getDataList()
  },
  methods: {
    changeStatusHandle (valueKey) {
      if (this.dataLoading) {
        return false
      }
      if (valueKey === this.activited) {
        return false
      }
      this.activited = valueKey
      this.getDataList(1)
    },
    handleSizeChange (val) {
      this.getDataList(1)
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getDataList()
    },
    getDataList (page = this.currentPage) {
      this.currentPage = page
      this.$http.post(`/front/train/${this.activited === 'getRegister' ? 'uservisitor/list' : 'trainusermyinvitation/selectInvitationBuy'}`,
        {
          'page': this.currentPage,
          'limit': this.pageSize
        }).then(({ data }) => {
        // console.log(data)
        if (data.code === 0) {
          this.dataList = data.data.data || []
          // this.totalPage = data.data.data.count
          // 分页
          this.totalPage = Number(data.data.count) || 0
          // this.changePageTo(this.currentPage)
        }
      })
      // this.jumpTargetPage = 1
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.getDataList(1)
    },
    // 当前页
    currentChangeHandle (val) {
      this.getDataList(val)
    },
    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
    }
  }
}
</script>
<style scoped>
.myAsk{
    width:60px;
    text-align: center;
}
.buy-list{
    margin:0 69px;
}
.buy-item{
    width:100%;
    height:120px;
    padding:20px 0;
    border-bottom:1px solid #ccc;
}
.buy-img{
    width:120px;
    height:80px;
    float:left;
    padding-left:20px;
}
.buy-img img{
    width:80px;
    height:80px;
    border-radius: 50%;
}
.buy-info{
    width: 400px;
    height:80px;
    float:left;
    margin-left:10px;
    padding-top:5px;
}
.buy-info p{
    margin:5px;
    margin-top:10px;
    color:#333;
}
.buy-info p span{
    color:#999
}
.buy-time{
    width:205px;
    height:80px;
    float:right;
    padding-top:50px;
    color:#999
}
</style>
